<template><div /></template>

<script>
  export default {
    name: 'CorrigeOPacDaUgbtComODaUcbt'
  };
</script>
